import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  connect() {
    const picture = this.element.querySelector("[data-link-in-bio-hero-picture]");
    const image = picture?.querySelector("img");
    if (!picture || !image) return;

    const updateOrientation = () => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      picture.dataset.imageOrientation = image.naturalWidth > image.naturalHeight
        ? "landscape"
        : (image.naturalWidth === image.naturalHeight ? "square" : "portrait");
    };

    if (image.complete) updateOrientation();
    else image.addEventListener("load", updateOrientation, { once: true });
  }
}
